module.exports = __webpack_public_path__ + "img/menu11.c12efa25.png";